import type { CraftingRecipe } from '../types';

export const CRAFTING_RECIPES: CraftingRecipe[] = [
    // --- SMELTING ---
    {
        id: 'smelt_copper',
        name: 'Copper Bar',
        level: 1,
        xp: 10,
        duration: 3000,
        category: 'smelting',
        input: { copper: 5 },
        output: { copper_bar: 1 }
    },
    {
        id: 'smelt_tin',
        name: 'Tin Bar',
        level: 5,
        xp: 15,
        duration: 3000,
        category: 'smelting',
        input: { tin: 5 },
        output: { tin_bar: 1 }
    },
    {
        id: 'smelt_iron',
        name: 'Iron Bar',
        level: 15,
        xp: 25,
        duration: 5000,
        category: 'smelting',
        input: { iron: 5, coal: 2 },
        output: { iron_bar: 1 }
    },
    {
        id: 'smelt_silver',
        name: 'Silver Bar',
        level: 30,
        xp: 40,
        duration: 8000,
        category: 'smelting',
        input: { silver_ore: 5, coal: 3 },
        output: { silver_bar: 1 }
    },
    {
        id: 'smelt_gold',
        name: 'Gold Bar',
        level: 50,
        xp: 60,
        duration: 12000,
        category: 'smelting',
        input: { gold_ore: 5, coal: 5 },
        output: { gold_bar: 1 }
    },
    {
        id: 'smelt_mithril',
        name: 'Mithril Bar',
        level: 60,
        xp: 80,
        duration: 15000,
        category: 'smelting',
        input: { mithril_ore: 5, coal: 10 },
        output: { mithril_bar: 1 }
    },
    {
        id: 'smelt_adamantite',
        name: 'Adamantite Bar',
        level: 70,
        xp: 110,
        duration: 20000,
        category: 'smelting',
        input: { adamantite_ore: 5, coal: 15 },
        output: { adamantite_bar: 1 }
    },
    {
        id: 'smelt_runite',
        name: 'Runite Bar',
        level: 85,
        xp: 150,
        duration: 30000,
        category: 'smelting',
        input: { runite_ore: 5, coal: 25 },
        output: { runite_bar: 1 }
    },
    {
        id: 'smelt_titanium',
        name: 'Titanium Bar',
        level: 90,
        xp: 200,
        duration: 40000,
        category: 'smelting',
        input: { titanium: 5, coal: 30 },
        output: { titanium_bar: 1 }
    },
    {
        id: 'smelt_uranium',
        name: 'Uranium Rod',
        level: 95,
        xp: 350,
        duration: 60000,
        category: 'smelting',
        input: { uranium: 10 },
        output: { uranium_rod: 1 }
    },

    // --- COOKING ---
    {
        id: 'cook_mash',
        name: 'Mashed Potatoes',
        level: 1,
        xp: 15,
        duration: 2000,
        category: 'cooking',
        input: { potato: 3 },
        output: { mashed_potatoes: 1 }
    },
    {
        id: 'cook_bread',
        name: 'Bread',
        level: 5,
        xp: 20,
        duration: 3000,
        category: 'cooking',
        input: { wheat: 3 },
        output: { bread: 1 }
    },
    {
        id: 'cook_beer',
        name: 'Beer',
        level: 10,
        xp: 30,
        duration: 5000,
        category: 'cooking',
        input: { wheat: 2, hops: 2 },
        output: { beer: 1 }
    },
    {
        id: 'cook_stew',
        name: 'Carrot Stew',
        level: 20,
        xp: 45,
        duration: 6000,
        category: 'cooking',
        input: { carrot: 3, potato: 2 },
        output: { carrot_stew: 1 }
    },
    {
        id: 'cook_alien',
        name: 'Alien Stew',
        level: 70,
        xp: 200,
        duration: 15000,
        category: 'cooking',
        input: { alien_flora: 10 },
        output: { alien_stew: 1 }
    },
    {
        id: 'cook_elixir',
        name: 'Elixir of Life',
        level: 90,
        xp: 1000,
        duration: 60000,
        category: 'cooking',
        input: { herbs: 20, crystal_tree: 5, gold_bar: 1 },
        output: { elixir_of_life: 1 }
    },


    // --- MANUFACTURING ---
    {
        id: 'make_wire',
        name: 'Copper Wire',
        level: 5,
        xp: 20,
        duration: 2000,
        category: 'manufacturing',
        input: { copper_bar: 1 },
        output: { copper_wire: 5 }
    },
    {
        id: 'make_gear',
        name: 'Iron Gear',
        level: 20,
        xp: 50,
        duration: 5000,
        category: 'manufacturing',
        input: { iron_bar: 2 },
        output: { iron_gear: 1 }
    },
    {
        id: 'make_circuit',
        name: 'Electronic Circuit',
        level: 30,
        xp: 75,
        duration: 8000,
        category: 'manufacturing',
        input: { copper_wire: 5, gold_bar: 1 },
        output: { electronic_circuit: 1 }
    },
    {
        id: 'make_battery',
        name: 'Battery',
        level: 45,
        xp: 100,
        duration: 10000,
        category: 'manufacturing',
        input: { copper_bar: 3, tin_bar: 1 },
        output: { battery: 1 }
    },
    {
        id: 'make_adv_circuit',
        name: 'Advanced Circuit',
        level: 60,
        xp: 150,
        duration: 15000,
        category: 'manufacturing',
        input: { electronic_circuit: 2, mithril_bar: 2 },
        output: { advanced_circuit: 1 }
    },
    {
        id: 'make_engine',
        name: 'Engine Component',
        level: 70,
        xp: 250,
        duration: 25000,
        category: 'manufacturing',
        input: { iron_gear: 10, adamantite_bar: 5 },
        output: { engine: 1 }
    },
    {
        id: 'make_ai',
        name: 'AI Core',
        level: 85,
        xp: 500,
        duration: 40000,
        category: 'manufacturing',
        input: { advanced_circuit: 5, quantum_processor: 1, runite_bar: 2 },
        output: { ai_core: 1 }
    },
    {
        id: 'make_quantum',
        name: 'Quantum Processor',
        level: 80,
        xp: 400,
        duration: 35000,
        category: 'manufacturing',
        input: { advanced_circuit: 4, gold_bar: 10, time_crystals: 5 },
        output: { quantum_processor: 1 }
    },

    // --- EQUIPMENT ---
    {
        id: 'craft_copper_pick',
        name: 'Copper Pickaxe',
        level: 5,
        xp: 50,
        duration: 5000,
        category: 'equipment', // Using 'equipment' but note types.ts interface says 'smelting' | 'cooking' | 'manufacturing'
        // I need to update the interface in types.ts as well!
        input: { copper_bar: 3, wood: 2 },
        output: { copper_pickaxe: 1 }
    },
    {
        id: 'craft_iron_pick',
        name: 'Iron Pickaxe',
        level: 20,
        xp: 100,
        duration: 10000,
        category: 'equipment',
        input: { iron_bar: 3, wood: 2 },
        output: { iron_pickaxe: 1 }
    },
    {
        id: 'craft_mithril_pick',
        name: 'Mithril Pickaxe',
        level: 60,
        xp: 500,
        duration: 30000,
        category: 'equipment',
        input: { mithril_bar: 5, wood: 5 },
        output: { mithril_pickaxe: 1 }
    },
    {
        id: 'craft_adamant_pick',
        name: 'Adamantite Pickaxe',
        level: 70,
        xp: 1000,
        duration: 45000,
        category: 'equipment',
        input: { adamantite_bar: 5, wood: 10 },
        output: { adamantite_pickaxe: 1 }
    },
    {
        id: 'craft_rune_pick',
        name: 'Runite Pickaxe',
        level: 85,
        xp: 2500,
        duration: 60000,
        category: 'equipment',
        input: { runite_bar: 5, wood: 20 },
        output: { runite_pickaxe: 1 }
    },
    {
        id: 'craft_laser',
        name: 'Laser Drill',
        level: 95,
        xp: 5000,
        duration: 100000,
        category: 'equipment',
        input: { titanium_bar: 10, advanced_circuit: 5, battery: 5 },
        output: { laser_drill: 1 }
    },

    // --- ARMOR (New) ---
    // Copper
    { id: 'craft_copper_helm', name: 'Copper Helmet', level: 5, xp: 40, duration: 4000, category: 'equipment', input: { copper_bar: 3 }, output: { copper_helmet: 1 } },
    { id: 'craft_copper_plate', name: 'Copper Platebody', level: 10, xp: 80, duration: 6000, category: 'equipment', input: { copper_bar: 5 }, output: { copper_platebody: 1 } },
    { id: 'craft_copper_legs', name: 'Copper Platelegs', level: 8, xp: 60, duration: 5000, category: 'equipment', input: { copper_bar: 4 }, output: { copper_platelegs: 1 } },
    // Iron
    { id: 'craft_iron_helm', name: 'Iron Helmet', level: 20, xp: 100, duration: 8000, category: 'equipment', input: { iron_bar: 3 }, output: { iron_helmet: 1 } },
    { id: 'craft_iron_plate', name: 'Iron Platebody', level: 25, xp: 200, duration: 12000, category: 'equipment', input: { iron_bar: 5 }, output: { iron_platebody: 1 } },
    { id: 'craft_iron_legs', name: 'Iron Platelegs', level: 22, xp: 150, duration: 10000, category: 'equipment', input: { iron_bar: 4 }, output: { iron_platelegs: 1 } },
    // Mithril
    { id: 'craft_mithril_helm', name: 'Mithril Helmet', level: 50, xp: 500, duration: 20000, category: 'equipment', input: { mithril_bar: 3 }, output: { mithril_helmet: 1 } },
    { id: 'craft_mithril_plate', name: 'Mithril Platebody', level: 55, xp: 800, duration: 30000, category: 'equipment', input: { mithril_bar: 5 }, output: { mithril_platebody: 1 } },
    { id: 'craft_mithril_legs', name: 'Mithril Platelegs', level: 52, xp: 600, duration: 25000, category: 'equipment', input: { mithril_bar: 4 }, output: { mithril_platelegs: 1 } },
    // Adamantite
    { id: 'craft_addy_helm', name: 'Adamantite Helmet', level: 70, xp: 1000, duration: 35000, category: 'equipment', input: { adamantite_bar: 3 }, output: { adamantite_helmet: 1 } },
    { id: 'craft_addy_plate', name: 'Adamantite Platebody', level: 75, xp: 1500, duration: 50000, category: 'equipment', input: { adamantite_bar: 5 }, output: { adamantite_platebody: 1 } },
    { id: 'craft_addy_legs', name: 'Adamantite Platelegs', level: 72, xp: 1200, duration: 42000, category: 'equipment', input: { adamantite_bar: 4 }, output: { adamantite_platelegs: 1 } },
    // Runite
    { id: 'craft_rune_helm', name: 'Runite Helmet', level: 85, xp: 3000, duration: 60000, category: 'equipment', input: { runite_bar: 3 }, output: { runite_helmet: 1 } },
    { id: 'craft_rune_plate', name: 'Runite Platebody', level: 90, xp: 5000, duration: 80000, category: 'equipment', input: { runite_bar: 5 }, output: { runite_platebody: 1 } },
    { id: 'craft_rune_legs', name: 'Runite Platelegs', level: 88, xp: 4000, duration: 70000, category: 'equipment', input: { runite_bar: 4 }, output: { runite_platelegs: 1 } },

    // --- JEWELRY (New) ---
    { id: 'craft_gold_ring', name: 'Gold Ring', level: 25, xp: 80, duration: 5000, category: 'equipment', input: { gold_bar: 1 }, output: { gold_ring: 1 } },
    { id: 'craft_gold_neck', name: 'Gold Necklace', level: 30, xp: 100, duration: 6000, category: 'equipment', input: { gold_bar: 2 }, output: { gold_necklace: 1 } },
    { id: 'craft_silver_ring', name: 'Silver Ring', level: 15, xp: 50, duration: 4000, category: 'equipment', input: { silver_bar: 1 }, output: { silver_ring: 1 } },
    { id: 'craft_silver_neck', name: 'Silver Necklace', level: 20, xp: 70, duration: 5000, category: 'equipment', input: { silver_bar: 2 }, output: { silver_necklace: 1 } },

    // --- ADVANCED FOOD (New) ---
    { id: 'cook_flour', name: 'Flour', level: 3, xp: 5, duration: 1000, category: 'cooking', input: { wheat: 1 }, output: { flour: 5 } },
    { id: 'cook_dough', name: 'Dough', level: 4, xp: 8, duration: 1000, category: 'cooking', input: { flour: 1 }, output: { dough: 1 } },
    { id: 'cook_cornbread', name: 'Corn Bread', level: 12, xp: 35, duration: 4000, category: 'cooking', input: { corn: 2, flour: 1 }, output: { corn_bread: 1 } },
    { id: 'cook_popcorn', name: 'Popcorn', level: 8, xp: 25, duration: 2000, category: 'cooking', input: { corn: 2 }, output: { popcorn: 5 } },
    { id: 'cook_veggies', name: 'Roasted Veggies', level: 18, xp: 50, duration: 5000, category: 'cooking', input: { potato: 2, carrot: 2, herbs: 1 }, output: { roasted_veggies: 1 } },
    { id: 'cook_salad', name: 'Fruit Salad', level: 60, xp: 150, duration: 8000, category: 'cooking', input: { alien_flora: 2, crystal_tree: 1 }, output: { fruit_salad: 1 } }, // Re-using crystal tree as fruit?

    // --- ADVANCED MANUFACTURING (New) ---
    { id: 'make_plate', name: 'Reinforced Plate', level: 40, xp: 120, duration: 10000, category: 'manufacturing', input: { iron_bar: 2, coal: 2 }, output: { reinforced_plate: 1 } },
    { id: 'make_encell', name: 'Energy Cell', level: 55, xp: 200, duration: 15000, category: 'manufacturing', input: { battery: 1, gold_bar: 2 }, output: { energy_cell: 1 } },
    { id: 'make_frame', name: 'Robot Frame', level: 75, xp: 600, duration: 30000, category: 'manufacturing', input: { titanium_bar: 5, adamantite_bar: 5, reinforced_plate: 2 }, output: { robot_frame: 1 } },
    { id: 'make_shield', name: 'Force Field', level: 88, xp: 1000, duration: 40000, category: 'manufacturing', input: { energy_cell: 5, aetherium: 2 }, output: { force_field: 1 } },
    { id: 'make_warp', name: 'Warp Drive', level: 99, xp: 5000, duration: 100000, category: 'manufacturing', input: { engine: 2, dark_matter: 1, time_crystals: 5 }, output: { warp_drive: 1 } },

    // --- CONSUMABLES (New) ---
    { id: 'craft_dynamite', name: 'Dynamite', level: 15, xp: 50, duration: 5000, category: 'manufacturing', input: { coal: 10, stone: 10 }, output: { dynamite: 1 } }
];
